import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { SigningServiceHttp } from 'app/main/signing-pages/signing-service';

export interface SigningData {
  all_fields_data: object;
  third_party_auth_response?: object;
}

@Injectable({
  providedIn: 'root'
})
export class OnlineContractService {

  constructor(
    private http: SigningServiceHttp
  ) {
  }
  
  public httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "multipart/form-data"
    })
  }

  /**
   * get the document detail for signing
   * @param role_id 
   * @returns 
   */
  getTemplateDetail(id: number, uuid:string) {
    return this.http.get(`eform-signing/${id}`, {params: {uuid}});
  }

  /**
   * sign the document
   * @param data 
   * @returns 
   */
  signOnlineContract(data: SigningData, template_id: number) {
    return this.http.post(`eform-signing/${template_id}/process`, data);
  }

  /**
   * send online contract invitation
   * @param data 
   * @returns 
   */
  sendOnlineContractInvitation(data: SigningData, template_id: number) {
    return this.http.post(`eform-signing/${template_id}/send-invitation`, data);
  }
}